import ShDelButton from './src/main.vue'

ShDelButton.install = function(Vue) {
  Vue.component(ShDelButton.name, ShDelButton)
}

export default ShDelButton
